import Cookies from 'js-cookie';
import { Channel } from '@at/consumer-web-types';
import { getItemFromStorage, getItemLocalStorage, removeItemLocalStorage, setItemLocalStorage, USER_LOCATION_LATITUDE_STORAGE_KEY, USER_LOCATION_LONGITUDE_STORAGE_KEY, USER_LOCATION_POSTCODE_STORAGE_KEY, } from '@at/window-utils';
import { mapAdvertQueryCapabilitiesToStorage } from './capabilities.util';
export const SEARCH_CARS_USED_LOCAL_STORAGE = `search.filters.${Channel.cars}.used`;
export const SEARCH_VANS_USED_LOCAL_STORAGE = `search.filters.${Channel.vans}.used`;
export const SEARCH_BIKES_USED_LOCAL_STORAGE = `search.filters.${Channel.bikes}.used`;
export const SEARCH_MOTORHOMES_USED_LOCAL_STORAGE = `search.filters.${Channel.motorhomes}.used`;
export const SEARCH_CARAVANS_USED_LOCAL_STORAGE = `search.filters.${Channel.caravans}.used`;
export const SEARCH_TRUCKS_USED_LOCAL_STORAGE = `search.filters.${Channel.trucks}.used`;
export const SEARCH_PLANT_USED_LOCAL_STORAGE = `search.filters.${Channel.plant}.used`;
export const SEARCH_FARM_USED_LOCAL_STORAGE = `search.filters.${Channel.farm}.used`;
export const SEARCH_CYCLE_USED_LOCAL_STORAGE = `search.filters.${Channel.cycles}.used`;
const getLocalStorageName = (channel) => {
    switch (channel) {
        case Channel.cars:
            return SEARCH_CARS_USED_LOCAL_STORAGE;
        case Channel.vans:
            return SEARCH_VANS_USED_LOCAL_STORAGE;
        case Channel.bikes:
            return SEARCH_BIKES_USED_LOCAL_STORAGE;
        case Channel.motorhomes:
            return SEARCH_MOTORHOMES_USED_LOCAL_STORAGE;
        case Channel.caravans:
            return SEARCH_CARAVANS_USED_LOCAL_STORAGE;
        case Channel.trucks:
            return SEARCH_TRUCKS_USED_LOCAL_STORAGE;
        case Channel.plant:
            return SEARCH_PLANT_USED_LOCAL_STORAGE;
        case Channel.farm:
            return SEARCH_FARM_USED_LOCAL_STORAGE;
        case Channel.cycles:
            return SEARCH_CYCLE_USED_LOCAL_STORAGE;
        default:
            return '';
    }
};
export const getPostcodeFromCookie = () => {
    const postcodeValue = !!Cookies.get('postcode') && Cookies.get('postcode');
    return (postcodeValue && postcodeValue.split('=').pop()) || '';
};
export const savePostcodeToCookie = (postcodeValue) => {
    const cookieValue = `postcode=${postcodeValue.replace(/\s/g, '')}`;
    Cookies.set('postcode', cookieValue);
};
export const getExistingPostcode = () => {
    return getItemLocalStorage(USER_LOCATION_POSTCODE_STORAGE_KEY) || '';
};
export const getExistingSearchFields = (channel) => {
    const existingPostcode = getExistingPostcode() || getPostcodeFromCookie();
    const localSearchName = getLocalStorageName(channel);
    const searchFilters = getItemLocalStorage(localSearchName);
    if (searchFilters) {
        const parsedSearchFields = searchFilters ? JSON.parse(searchFilters) : {};
        if (parsedSearchFields.latLong) {
            parsedSearchFields.postcode = null;
        }
        if (parsedSearchFields['minimumMileage']) {
            if (!parsedSearchFields.minMileage) {
                parsedSearchFields.minMileage = parsedSearchFields['minimumMileage'];
            }
            parsedSearchFields['minimumMileage'] = undefined;
        }
        if (parsedSearchFields['suppliedPriceTo']) {
            if (!parsedSearchFields.maxSuppliedPrice) {
                const maxSuppliedPrice = parsedSearchFields['suppliedPriceTo'];
                parsedSearchFields.maxSuppliedPrice = Number(maxSuppliedPrice);
            }
            parsedSearchFields['suppliedPriceTo'] = undefined;
        }
        if (parsedSearchFields['mainEnginePower']) {
            if (!parsedSearchFields.minEnginePower) {
                const minEnginePower = parsedSearchFields['mainEnginePower'];
                parsedSearchFields.minEnginePower = Number(minEnginePower);
            }
            parsedSearchFields['mainEnginePower'] = undefined;
        }
        if (parsedSearchFields['minEnginePower']) {
            if (parsedSearchFields['minEnginePower'] instanceof String) {
                const minEnginePower = parsedSearchFields['minEnginePower'];
                parsedSearchFields.minEnginePower = Number(minEnginePower);
            }
        }
        if (parsedSearchFields['maxEnginePower']) {
            if (parsedSearchFields['maxEnginePower'] instanceof String) {
                const maxEnginePower = parsedSearchFields['maxEnginePower'];
                parsedSearchFields.maxEnginePower = Number(maxEnginePower);
            }
        }
        if (parsedSearchFields['batteryRange']) {
            if (!parsedSearchFields.batteryRangeValue) {
                parsedSearchFields.batteryRangeValue = parsedSearchFields['batteryRange'];
            }
            parsedSearchFields['batteryRange'] = undefined;
        }
        if (parsedSearchFields['batteryTime']) {
            if (!parsedSearchFields.batteryQuickChargeTimeValue) {
                parsedSearchFields.batteryQuickChargeTimeValue = parsedSearchFields['batteryTime'];
            }
            parsedSearchFields['batteryTime'] = undefined;
        }
        if (parsedSearchFields['ccFrom']) {
            if (!parsedSearchFields.minEngineSizeCC) {
                parsedSearchFields.minEngineSizeCC = Number(parsedSearchFields['ccFrom']);
            }
            parsedSearchFields['ccFrom'] = undefined;
        }
        if (parsedSearchFields['ccTo']) {
            if (!parsedSearchFields.maxEngineSizeCC) {
                parsedSearchFields.maxEngineSizeCC = Number(parsedSearchFields['ccTo']);
            }
            parsedSearchFields['ccTo'] = undefined;
        }
        if (parsedSearchFields['licenceType']) {
            parsedSearchFields['licenceType'] = undefined;
        }
        return parsedSearchFields;
    }
    else {
        return { postcode: existingPostcode ? existingPostcode : null };
    }
};
export const saveToLocalStorage = (channel, query) => {
    if (query.postcode) {
        setItemLocalStorage(USER_LOCATION_POSTCODE_STORAGE_KEY, query.postcode);
        savePostcodeToCookie(query.postcode);
    }
    setItemLocalStorage(USER_LOCATION_LATITUDE_STORAGE_KEY, query.latLong ? query.latLong.split(',')[0] : '');
    setItemLocalStorage(USER_LOCATION_LONGITUDE_STORAGE_KEY, query.latLong ? query.latLong.split(',')[1] : '');
    const localSearchName = getLocalStorageName(channel);
    setItemLocalStorage(localSearchName, JSON.stringify(mapAdvertQueryCapabilitiesToStorage(query)));
};
export const resetLocalStorage = (channel) => {
    const localSearchName = getLocalStorageName(channel);
    removeItemLocalStorage(localSearchName);
};
const mapTPFSortOrder = (sortOrder) => {
    switch (sortOrder) {
        case 'price-asc':
            return 'PriceAsc';
        case 'price-desc':
            return 'PriceDesc';
        case 'datedesc':
            return 'Recent';
        case 'distance':
            return 'Distance';
        case '':
        case undefined:
            return '';
        default:
            return 'Distance';
    }
};
export const getSortOrder = (channel) => {
    const sortOrder = getItemFromStorage('selected-sort', 'sessionStorage') || '';
    switch (channel) {
        case Channel.trucks:
        case Channel.plant:
        case Channel.farm:
            return mapTPFSortOrder(sortOrder);
        default:
            return sortOrder;
    }
};
